import React from 'react';
import { spacesContent } from '../content';
import SpaceCard from '../components/spaces/SpaceCard';
import SpaceGallery from '../components/spaces/SpaceGallery';

const SpacesPage = () => {
  return (
    <div className="container">
      <h1>Prostory</h1>

      <div className="intro-text">
        <p>{spacesContent.introduction}</p>
      </div>

      <div className="spaces-gallery">
        {spacesContent.spaces.map((space) => (
          <SpaceCard key={space.id} space={space} />
        ))}

        <SpaceGallery gallery={spacesContent.gallery} />
      </div>
    </div>
  );
};

export default SpacesPage;
